import gql from 'graphql-tag';

export default gql`
    query GetYardTypes {
        getYardTypes {
            id
            descrip
        }
    }
`;
